import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { useRecaptchaAction } from "../lib/useRecaptchaAction";
import { RecaptchaDisclosure } from "../components/RecaptchaDisclosure";
import { toast } from "sonner";

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [busy, setBusy] = useState(false);
    const { getToken } = useRecaptchaAction();

    const onSubmit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            const recaptcha_token = await getToken("forgot_password");
            await api.post("/auth/forgot-password", { email, recaptcha_token });
            setSent(true);
            toast.success("Se a conta existir, enviámos instruções.");
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen grid lg:grid-cols-2" data-testid="forgot-page">
            <aside className="relative bg-[#0d1628] text-white hidden lg:flex flex-col justify-between p-12 grain">
                <Link to="/" className="font-display text-3xl tracking-tight">IHTP</Link>
                <div className="font-display italic text-3xl max-w-md">
                    Pequenas pausas também fazem parte do caminho.
                </div>
                <div className="label-caps text-white/50">Recuperação de acesso</div>
            </aside>
            <section className="flex items-center justify-center px-6 md:px-12 py-16">
                <div className="w-full max-w-md">
                    <h1 className="font-display text-4xl text-[#0d1628]">Recuperar palavra-passe</h1>
                    <p className="text-sm text-[#52525b] mt-3">Indique o seu email e nós enviaremos instruções para redefinir.</p>
                    {sent ? (
                        <div className="card-flat mt-10" data-testid="forgot-confirm">
                            <div className="label-caps">Pedido recebido</div>
                            <p className="text-[#0d1628] mt-3">Se existir uma conta associada a este email, receberá em breve um link de recuperação.</p>
                            <Link to="/login" className="btn-outline mt-6 inline-flex">Voltar ao login</Link>
                        </div>
                    ) : (
                        <form onSubmit={onSubmit} className="mt-10 space-y-6">
                            <div>
                                <label className="label-caps block mb-2">Email</label>
                                <input type="email" required className="input-clean" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
                            </div>
                            <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="forgot-submit">
                                {busy ? "A enviar..." : "Enviar instruções"}
                            </button>
                            <div className="text-sm"><Link to="/login" className="link-underline text-[#0d1628]">Voltar ao login</Link></div>
                            <RecaptchaDisclosure />
                        </form>
                    )}
                </div>
            </section>
        </div>
    );
}
